<template>
  <div class="mask-preview-render" v-if="available" :style="style">
    <canvas-component
      :canvas="canvas"
      :style="canvasStyle"
      @canvas="(e) => $emit('canvas', e)"
    />
    <slot></slot>
  </div>
</template>

<script>
import CanvasComponent from "@gocasebr/prisma/dist/canvas-component/CanvasComponent";
import { getMaterialFromFactory } from "@/api/factory-api/material-api/material.api.js";

export default {
  components: { CanvasComponent },
  props: {
    material: String,
    timestamp: [Number, String],
    customization: Object,
    height: Number,
  },
  data() {
    return {
      maskImage: null,
      previewContext: null,
    };
  },
  computed: {
    available() {
      return !!this.maskImage && !!this.previewContext;
    },
    scale() {
      const max =
        this.previewContext.height > this.previewContext.width
          ? this.previewContext.height
          : this.previewContext.width;
      return this.height / max;
    },
    style() {
      return {
        width: `${this.previewContext.width * this.scale}px`,
        height: `${this.previewContext.height * this.scale}px`,
        "-webkit-mask-image": `url(${this.maskImage}?t=${this.timestamp})`,
        "-o-mask-image": `url(${this.maskImage}?t=${this.timestamp})`,
        "-moz-mask-image": `url(${this.maskImage}?t=${this.timestamp})`,
        "mask-image": `url(${this.maskImage}?t=${this.timestamp})`,
      };
    },
    canvasStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: `top left`,
      };
    },
    canvas() {
      const { customization, previewContext } = this;
      return {
        admin: true,
        customization,
        previewContext,
        showTextBorder: true,
      };
    },
  },
  async mounted() {
    await getMaterialFromFactory(this.material).then((res) => {
      this.customization.logo = {
        x: res.logo_x,
        y: res.logo_y,
      };
      this.customization.canvasContext = {
        width: res.mask_data.width,
        height: res.mask_data.height,
      };
      this.previewContext = {
        width: res.mask_data.width,
        height: res.mask_data.height,
      };
      this.maskImage = res.mask_data.image;
    });
  },
};
</script>

<style lang="scss" scoped>
.mask-preview-render {
  position: relative;

  background: url(https://static-production.gocase.com.br/transparency.png);
  background-size: cover;

  mask-size: 100% 100%;
  mask-repeat: no-repeat;

  -webkit-mask-size: 100% 100%;
  -webkit-mask-repeat: no-repeat;

  -o-mask-size: 100% 100%;
  -o-mask-repeat: no-repeat;

  -moz-mask-size: 100% 100%;
  -moz-mask-repeat: no-repeat;
}
</style>
